<template>
  <BaseCard :title="'Eagle Project for LCA'" :highlightLastWord="false">
    <div class="flex flex-col justify-center gap-4">
      <div class="w-full grid lg:grid-cols-2 lg:gap-20">
        <h5 class="lg:justify-self-end lg:pr-6 font-medium">Project Manager & Leader</h5>
        <h5 class="lg:justify-self-start lg:pl-6 font-medium">April 2022 - August 2022</h5>
      </div>
      <p class="text-center items-center px-4 gap-2">
        <span class="block">
          As part of my journey to Eagle Scout, I returned to my grade school, Lakewood Catholic Academy, to give back after all that they had given 
          me. Given my experience in landscaping and leadership, I felt particularly drawn to the 2nd most used entrance to LCA, yet this entrance
          had almost zero life to it. A statue of Mary dedicated to a past faculty member stood alone, and I knew that needed to change.
        </span>
        <span class="block">
          Over the first 2 months, I wrote a 10-page project proposal, detailing the 3 main areas of landscaping revamp that I would be targeting as 
          well as procurement of materials, labor, and $1000 of funding for the project. My drive was restless, and I was approved by my troop's Eagle Project board of 8 members, my Scoutmaster, and Lake Erie Council all within 1 week. <br>
          From here, I pieced together a 30-page project plan, procuring materials/labor and scheduling the project at the same time. Over a single weekend, I organized and led over 20 Scouts and adults in installing 20 new perennials, a gravel seating area with 2 benches, and a new flower bed around the Mary statue in a grand total of 200 hours of service. Within two days of the project, I completed my 10-page project report and had my project approved by my Scoutmaster and Lake Erie Council as well. <br>
          To this day, LCA students and faculty use this space almost daily in season, and I often find myself reading in this space when I'm in the area.
        </span>
        <a href="https://drive.google.com/drive/folders/1PQ0kxLRNEFaV2E9w1UQO3OjVbdjeVT2S?usp=sharing" target="_blank" class="link-in-text">Photos!</a>
      </p>
      <span class="grid lg:grid-cols-2 gap-12 place-items-center overflow-hidden">
        <img class="w-full h-auto rounded-lg cursor-pointer" :src="EPShrubs" @click="openImageMenu(EPShrubs, 'Eagle Project Shrubs', $event.currentTarget)">
        <img class="w-full h-auto rounded-lg cursor-pointer" :src="EPBenches" @click="openImageMenu(EPBenches, 'Eagle Project Benches', $event.currentTarget)">
      </span>
    </div>
  </BaseCard>
</template>
  
<script lang="ts" setup>
import BaseCard from '@/features/global/BaseCard.vue';
import EPShrubs from '@/assets/Projects/EagleProjectPhotos/EPShrubs.png';
import EPBenches from '@/assets/Projects/EagleProjectPhotos/EPBenches.png';
import { useImageViewer } from '@/features/composables/useImageViewer';
const { openImageMenu } = useImageViewer();

</script>